import Vue from 'vue'
import axios from 'axios'
import store from '../../stores/index'
import router from '../../router/index'
axios.defaults.withCredentials = true
const api = axios.create()
let shouldDo401Redirect = true
api.interceptors.response.use(
    response => response,
    error => {
        // whatever you want to do with the error
        console.log(error.response.status)
        switch (error.response.status) {
            case 500:
                Vue.swal({
                    title: error.response.statusText,
                    text: error.response.data,
                    icon: 'error',
                })
                break
            case 400:
                console.log(error.response)
                Vue.swal({
                    title: error.response.statusText,
                    text: error.response.data,
                    icon: 'error',
                })
                break
            case 401:
                if (shouldDo401Redirect) {
                    shouldDo401Redirect = false
                    setTimeout(() => {
                        shouldDo401Redirect = true
                    }, 300)
                    store.commit('LOGOUT')
                    store.commit('DISABLESTAFFMODE')
                    setTimeout(() => {
                        window.location.href = 'https://ticketbot.xyz'
                    }, 2000)
                    Vue.swal({
                        title: 'Your session has expired:',
                        text: 'Please relog to refresh session',
                        toast: true,
                        timerProgressBar: true,
                        timer: 2000,
                        position: 'top-end',
                    })
                }
                break
            default:
                throw error
        }
    },
)

export default api



// WEBPACK FOOTER //
// ./src/api/apiClient/axios.js